import React, { useState, useEffect } from "react";
import axios from "axios";
import "./BookDonation.css";

const BookDonation = () => {
  const [cart, setCart] = useState({});
  const [loading, setLoading] = useState({
    donate: null,
    checkout: false
  });

  const bookData = [
    { title: "BHAGAVAD GITA", language: "TELUGU", price: 240 },
    { title: "BHAGAVAD GITA", language: "ENGLISH", price: 260 },
    { title: "BHAGAVAD GITA", language: "HINDI", price: 230 },
    { title: "RAMAYAN", language: "TELUGU", price: 250 },
    { title: "RAMAYAN", language: "ENGLISH", price: 250 },
    { title: "RAMAYAN", language: "HINDI", price: 250 },
    { title: "SB 1st canto", language: "TELUGU", price: 450 },
    { title: "SB 1st canto", language: "ENGLISH", price: 650 },
    { title: "SB 1st canto", language: "HINDI", price: 650 },
    { title: "MAHABHARAT", language: "ENGLISH", price: 320 },
    { title: "MAHABHARAT", language: "HINDI", price: 300 },
    { title: "MAHABHARAT", language: "TELUGU", price: 320 }
  ];

  const getQuantity = (key) => cart[key] || 0;

  const updateQuantity = (key, change) => {
    setCart((prev) => ({
      ...prev,
      [key]: Math.max(0, (prev[key] || 0) + change)
    }));
  };

  const getTotalAmount = () =>
    bookData.reduce((total, book) => {
      const key = `${book.title}-${book.language}`;
      return total + book.price * getQuantity(key);
    }, 0);

  // Function to handle individual book donation
  const handleBookDonation = async (book, quantity, key) => {
    if (quantity === 0) {
      alert("Please select at least 1 quantity to donate");
      return;
    }

    const amount = book.price * quantity;
    await initiatePayment(amount, `${book.title} (${book.language})`, quantity, 'single');
  };

  // Function to handle checkout (all items)
  const handleCheckout = async () => {
    const items = bookData
      .map(book => {
        const key = `${book.title}-${book.language}`;
        const quantity = getQuantity(key);
        if (quantity > 0) {
          return {
            bookTitle: book.title,
            language: book.language,
            quantity: quantity,
            price: book.price,
            total: book.price * quantity
          };
        }
        return null;
      })
      .filter(item => item !== null);

    if (items.length === 0) {
      alert("Please add at least one book to checkout");
      return;
    }

    const totalAmount = getTotalAmount();
    await initiatePayment(totalAmount, "Multiple Books", items, 'multiple');
  };

  // Use the same payment function as your Diwali form
  const initiatePayment = async (amount, description, items, type) => {
    let isFormDataStored = false;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/payment/create-order`,
        {
          amount: amount,
          currency: "INR",
        }
      );

      const order = response.data;
      let bookDescription = type === 'single' 
        ? `Book Donation - ${description} x ${items}` 
        : `Book Donation - ${items.length} Books`;

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: amount * 100,
        currency: "INR",
        name: "ISKCON Book Donation",
        description: bookDescription,
        order_id: order.id,
        notes: {
          donationType: "Book Donation",
          bookDetails: type === 'single' ? description : `Multiple books (${items.length})`,
          quantity: type === 'single' ? items : 'multiple',
          amount: amount,
        },
        handler: async function (response) {
          try {
            const verificationResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                donationDetails: {
                  amount: amount,
                  bookDetails: type === 'single' ? description : `Multiple books (${items.length})`,
                  paymentStatus: "Successful",
                  submissionDate: new Date().toISOString(),
                  type: "book-donation"
                },
              }
            );

            if (verificationResponse.data.success) {
              await storePaymentData("Payment Successful", amount, description, items, type);
              isFormDataStored = true;
              alert("Payment Successful! Thank you for your book donation.");
              // Clear cart after successful payment
              if (type === 'multiple') {
                setCart({});
              }
            }
          } catch (err) {
            console.error(err);
            alert("Payment verification failed");
            if (!isFormDataStored) {
              await storePaymentData("Payment Failed", amount, description, items, type);
              isFormDataStored = true;
            }
          }
        },
        theme: { color: "#C61D21" },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

      paymentObject.on("payment.failed", async function (response) {
        alert("Payment Failed: " + response.error.description);
        if (!isFormDataStored) {
          await storePaymentData("Payment Failed", amount, description, items, type);
          isFormDataStored = true;
        }
      });
    } catch (error) {
      console.error("Error initiating payment:", error);
      alert("Failed to initiate payment. Please try again.");
      if (!isFormDataStored) {
        await storePaymentData("Payment Failed", amount, description, items, type);
        isFormDataStored = true;
      }
    } finally {
      // Reset loading states
      if (type === 'single') {
        setLoading(prev => ({ ...prev, donate: null }));
      } else {
        setLoading(prev => ({ ...prev, checkout: false }));
      }
    }
  };

  // Function to store payment data
  const storePaymentData = async (paymentStatus, amount, description, items, type) => {
    const paymentData = {
      amount: amount,
      bookDetails: description,
      quantity: type === 'single' ? items : 'multiple',
      paymentStatus: paymentStatus,
      submissionDate: new Date().toISOString(),
      type: "book-donation"
    };

    const formBody = new URLSearchParams(paymentData).toString();

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbzxYif8qOVlVduU4e4dPx18NaFI7SxLzOyIHpd1btJERywNXgC3dS2e19pLOmIQC-yvZQ/exec",
        {
          method: "POST",
          body: formBody,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
    } catch (error) {
      console.error("Payment data storage error:", error);
    }
  };

  // Check if specific donate button is loading
  const isDonateButtonLoading = (key) => loading.donate === key;

  // Load Razorpay script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="book-simple-container">
      {/* Donation Details Header */}
      <div className="donation-header">
        <h2>Donation Details</h2>
        {/* <p>Select the books you wish to donate and choose the quantity</p> */}
      </div>

      {bookData.map((book, i) => {
        const key = `${book.title}-${book.language}`;
        const quantity = getQuantity(key);
        const itemTotal = quantity > 0 ? book.price * quantity : book.price;
        const isThisDonateLoading = isDonateButtonLoading(key);
        
        return (
          <div className="book-simple-card" key={i}>
            {/* Book title on left */}
            <div className="row-left">
              <span className="title">
                {book.title} ({book.language})
              </span>
            </div>

            {/* Right side: Amount + Quantity + Donate button with gaps */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '35px' }}>
              <span className="price">₹{itemTotal}/-</span>
              
              <div className="row-middle">
                <button 
                  onClick={() => updateQuantity(key, -1)}
                  disabled={isThisDonateLoading || loading.checkout}
                >
                  -
                </button>
                <span>{quantity}</span>
                <button 
                  onClick={() => updateQuantity(key, 1)}
                  disabled={isThisDonateLoading || loading.checkout}
                >
                  +
                </button>
              </div>

              <button 
                className="donate-btn"
                onClick={() => handleBookDonation(book, quantity, key)}
                disabled={isThisDonateLoading || loading.checkout || quantity === 0}
              >
                {isThisDonateLoading ? "Processing..." : "Donate"}
              </button>
            </div>
          </div>
        );
      })}

      {getTotalAmount() > 0 && (
        <div className="simple-summary">
          <span>Total: ₹ {getTotalAmount()}</span>
          <button 
            className="checkout-btn"
            onClick={handleCheckout}
            disabled={loading.checkout || loading.donate !== null}
          >
            {loading.checkout ? "Processing..." : "Donate"}
          </button>
        </div>
      )}
    </div>
  );
};

export default BookDonation;